import React, {useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import {useApiSearchAdminImport} from "@/api/import";

import {Button, Card, Descriptions, Drawer, Tag, Typography} from "antd";
import {Link} from "react-router-dom";
import TableSearch from "@/components/table/tableSearch";
import {EyeOutlined, FileExcelOutlined} from "@ant-design/icons";
import {formatDateFull} from "@/lib/utils/date";

const {Text} = Typography;

function AdminImportList(props) {

    const [selectedRow, setSelectedRow] = useState(null);

    const getStatusTag = (status) => {
        switch (status) {
            case "completed":
                return <Tag color="success">موفق</Tag>;

            case "failed":
                return <Tag color="red">خطا</Tag>;

            case "in_progress":
                return <Tag color="red-inverse">در حال پردازش</Tag>;

            case "pending":
                return <Tag color="blue">در انتظار پردازش</Tag>;

            default:
                return <Tag>{status}</Tag>;
        }
    };

    const columns = [
        {
            title: "#",
            dataIndex: "id",

        },
        {
            title: "فایل",
            render: (_, record) => (
                <>
                    <FileExcelOutlined
                        style={{
                            color: "#52c41a",
                            fontSize: 18
                        }}
                    />

                    <div>
                        <div>{record.file?.filename}</div>

                        <Text type="secondary">
                            {(record.file?.size / 1024).toFixed(1)} KB
                        </Text>
                    </div>
                </>
            )
        },
        {
            title: "نوع",
            dataIndex: "type",
            width: 120
        },
        {
            title: "وضعیت",
            dataIndex: "status",
            width: 150,
            render: getStatusTag
        },

        {
            title: "تاریخ ایجاد",
            render: (_, record) => (
                <span>
                    {formatDateFull(record.created_at)}
                </span>
            )
        },
        {
            title: "عملیات",
            width: 120,
            render: (_, record) => (
                <span>
                    <Button
                        icon={<EyeOutlined/>}
                        onClick={() => setSelectedRow(record)}
                    >
                        جزئیات
                    </Button>
                </span>

            )
        }
    ];

    return (
        <AdminLayout pageTitle={'وارد سازی داده انبوه'} backTo={URLS.admin.setting.dashboard}>
            <div className={'flex justify-end'}>
                <Link className={'mb-2'} to={URLS.admin.import.create}>
                    <Button color={'primary'} variant={'solid'}>
                        افزودن وارد سازی جدید
                    </Button>
                </Link>
            </div>

            <TableSearch columns={columns} apiFn={useApiSearchAdminImport}
            />

            <Drawer
                title={`جزئیات ایمپورت #${selectedRow?.id}`}
                width={650}
                open={!!selectedRow}
                onClose={() => setSelectedRow(null)}
            >
                {selectedRow && (
                    <>
                        <Descriptions
                            bordered
                            column={1}
                            size="small"
                        >
                            <Descriptions.Item label="شناسه">
                                {selectedRow.id}
                            </Descriptions.Item>

                            <Descriptions.Item label="نوع">
                                {selectedRow.type}
                            </Descriptions.Item>

                            <Descriptions.Item label="وضعیت">
                                {getStatusTag(selectedRow.status)}
                            </Descriptions.Item>

                            <Descriptions.Item label="پیام سیستم">
                                <code style={{direction: 'ltr'}} className={'text-left'}>

                                    {selectedRow.result?.message || "-"}
                                </code>
                            </Descriptions.Item>

                            <Descriptions.Item label="نام فایل">
                                {selectedRow.file?.filename}
                            </Descriptions.Item>

                            <Descriptions.Item label="نوع فایل">
                                {selectedRow.file?.mime}
                            </Descriptions.Item>
                            <Descriptions.Item label="حجم فایل">
                                {selectedRow.file?.size} Byte
                            </Descriptions.Item>
                            <Descriptions.Item label="دانلود فایل">
                                <Link to={selectedRow?.file?.url} target={`_blank`} download={true}>
                                    <Button type={'primary'}>دانلود</Button>
                                </Link>
                            </Descriptions.Item>


                            <Descriptions.Item label="تاریخ ایجاد">
                                {formatDateFull(selectedRow.created_at)}
                            </Descriptions.Item>

                        </Descriptions>

                        {selectedRow.status === "failed" && (
                            <Card
                                size="small"
                                style={{marginTop: 16}}
                                title="جزئیات خطا"
                            >
                                <pre
                                    className={'ltr text-left '}
                                    style={{
                                        direction: 'ltr',
                                        margin: 0,
                                        whiteSpace: "pre-wrap"
                                    }}
                                >
                                    <code>
                                        {JSON.stringify(
                                            selectedRow.result,
                                            null,
                                            2
                                        )}
                                    </code>

                                </pre>
                            </Card>
                        )}
                    </>
                )}
            </Drawer>
        </AdminLayout>
    );
}

export default AdminImportList;